export interface ControlLockMode {
  id: string;
  deviceId: string;
  note: string;
  updatedBy: string;
  mode: string;
  createdAt: string;
}

export interface LockedDeviceInfo {
  deviceId: string;
  note: string;
  updatedBy: string;
  updatedAt: string;
}

export enum ControlLockModeEnum {
  LOCKED = 'locked',
  UNLOCKED = 'unlocked',
}
